import { OktaConfig } from '@okta/okta-angular';
import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js';
import { ConfigurationService } from 'src/app/core/configuration.service';

export function oktaConfigFactory(configService: ConfigurationService): OktaConfig {
  const config = configService.value;
  const oktaRedirect =
    window.location.protocol + '//' + window.location.host + '/implicit/callback';
  const issuer = `${config.okta.tenantUrl}/oauth2/default`;

  const oktaConfig: OktaAuthOptions = {
    issuer,
    scopes: ['email', 'openid'],
    clientId: config.okta.clientId,
    redirectUri: oktaRedirect,
  };
  return { oktaAuth: new OktaAuth(oktaConfig) };
}
